var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { BaseService } from '../baseService';
export class LivequeuChatService extends BaseService {
    constructor(props) {
        super(props);
    }
    getChatsIds() {
        return this.api.fetchOpenApi('chats/ids', 'get');
    }
    chatsSearch() {
        return this.api.fetchOpenApi('chats/search', 'post', {});
    }
    getChatsSubscriptions(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.fetchOpenApi('chats/subscriptions/search', 'post', params);
        });
    }
    createChat() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi('chats', 'post', {});
            const chatId = data._id;
            if (!chatId)
                return data;
            const userId = $auth.account.userId;
            if (userId) {
                yield this.subscribeChat({ chat_id: chatId, user_id: userId });
            }
            return data;
        });
    }
    subscribeChat(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { chat_id, user_id } = params;
            if (!chat_id || !user_id)
                throw new Error('chat_id and user_id required');
            return this.api.fetchOpenApi(`chats/${chat_id}/subscribe`, 'post', { user_id });
        });
    }
    sendChatMessage(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { chat_id, content } = params;
            return this.api.fetchOpenApi(`chats/${chat_id}/messages`, 'post', { content });
        });
    }
    getChatMessages(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { chat_id } = params, otherParams = __rest(params, ["chat_id"]);
            const cleanParams = Object.fromEntries(Object.entries(otherParams).filter(([_, v]) => v !== undefined));
            return this.api.fetchOpenApi(`chats/${chat_id}/messages/search`, 'post', cleanParams);
        });
    }
    getDashboardItems(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.fetchOpenApi(`/chats/messages/dashboard-search`, 'post', params);
        });
    }
    markMessageAsRead(chat_id, message_id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.api.fetchOpenApi(`chats/${chat_id}/messages/${message_id}/read`, 'post');
        });
    }
}
